import { requestGetJSON } from '../../../../NonReact/common/API/REST/RESTAPIClient'
import { DeviceByBWIDAPIDTO, SSOAppDTO } from '../../../../React/BroadworksSSO/Types/Types'
import { getDeviceByIDOnTelSysURL } from '../../../../NonReact/constants/ApiConstants'
import { isStringNotEmpty } from '../../../../NonReact/utils/GlobalFunctions'
import { redirectToURL } from '../../../../NonReact/utils/LocationUtils'
import { URLConstructor } from '../../../../NonReact/utils/URLBuilder'
import { BroadworksSSOConfigDTO } from '../../../../NonReact/Types/Types'
import { JSONResponse } from '../../../../NonReact/common/Types/Types'

/**
 * Attempts to login to Broadworks SSO.
 *
 * @param username - The username to login with.
 * @param broadworksSSOConfig - The Broadworks SSO configuration.
 */
export const attemptBroadworksSSOLogin = (
    username: string,
    broadworksSSOConfig: Nullable<BroadworksSSOConfigDTO>
): Promise<void> =>
    requestGetJSON<DeviceByBWIDAPIDTO>(getDeviceByIDOnTelSysURL(username)).then(
        (res: JSONResponse<DeviceByBWIDAPIDTO>): void => {
            if (res) {
                if (broadworksSSOConfig?.broadworksSSOAppURL) {
                    const dtoData: SSOAppDTO = {
                        username,
                        authServerAddress: res.XSPServerIPAddress,
                        authServerContext: res.XSPServerAuthServiceContextPath,
                        authServerVersion: res.XSPServerSchemaVersion,
                        refererDomain: isStringNotEmpty(res.InstanceDomainName)
                            ? res.InstanceDomainName
                            : window.location.hostname
                    }

                    redirectToURL(
                        URLConstructor.newInstance({
                            baseURL: broadworksSSOConfig.broadworksSSOAppURL
                        }).appendQueryParams({
                            ...(broadworksSSOConfig?.encodeURLParamForSSOApp
                                ? {
                                      data: btoa(JSON.stringify(dtoData))
                                  }
                                : dtoData)
                        })
                    )
                }
            }
        }
    )
